import { render } from "./StarryBackground.vue?vue&type=template&id=3993181f&scoped=true&ts=true"
import script from "./StarryBackground.vue?vue&type=script&lang=ts"
export * from "./StarryBackground.vue?vue&type=script&lang=ts"

import "./StarryBackground.vue?vue&type=style&index=0&id=3993181f&scoped=true&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3993181f"]])

export default __exports__